import React from "react";

export default class Tips extends React.Component  
{
    constructor(props)    
    {
        super(props);

        this.populars = this.props.populars.length > 0 ? this.props.populars : [];
    }
    
    render()
    {
        return (
            <div className="popular-articles-sidebar-tips mb-5">               
                <div className="card">
                    <h3>Tips & Advice</h3>   
                {
                    this.populars.map(popular =>
                    {
                        return(
                            <div className="article">
                                <a href={popular.url} className="article">          
                                    <div className="text">{popular.title}</div>
                                </a>
                            </div> 

                        )   
                    })
                }
                <div className="article">
                    <a href="/blog" className="article">          
                        <div className="text">{`View more >>`}</div>
                    </a>
                </div>                  
                </div>
            </div>
        )
    }
};